/** @jsx jsx */
import { jsx, Heading, useColorMode, Link as TLink } from "theme-ui"
import { Link } from "gatsby"
import { Flex } from "@theme-ui/components"
import Layout from "./layout"
import Listing from "./listing"
import useMinimalBlogConfig from "../hooks/use-minimal-blog-config"
import replaceSlashes from "../utils/replaceSlashes"
import SEO from "./seo"
import ColorModeToggle from "./colormode-toggle"


type ProjectProps = {
  posts: {
    slug: string
    title: string
    date: string
    excerpt: string
    description: string
    timeToRead?: number
    tags?: {
      name: string
      slug: string
    }[]
  }[]
}

const Blog = ({ posts }: ProjectProps) => {
  const { tagsPath, basePath } = useMinimalBlogConfig()
  
  const [colorMode, setColorMode] = useColorMode()
  const isDark = colorMode === `dark`
  const toggleColorMode = (e: any) => {
    e.preventDefault()
    setColorMode(isDark ? `light` : `dark`)
  }

  return (
    <Layout>
        <SEO title="Projects" />
        <div 
            sx={{ borderRadius: `50px`, 
                  background: isDark ? `#313949` :`#eeeeee`,
                  boxShadow: isDark ? `9px 9px 30px #292f3d, -9px -9px 30px #394355` : `9px 9px 28px #e0e0e0, -9px -9px 28px #fcfcfc`,
                  // For some reason the bottom padding is either 0 or at 1 is way too big
                  padding: `10px clamp(10px, 4vw, 50px) 10px clamp(10px, 4vw, 50px)`,
                  marginBottom: `100px`
                  //Change height of Projects container
                  //height: `2230px`,
                }}
            >
     <Flex sx={{ alignItems: `center`, justifyContent: `space-between`, flexFlow: `wrap`}}>
        <Heading variant="styles.h2" sx={{padding: `0px 0px 0px min(10px)`}}>
            Projects
      </Heading>
      <TLink as={Link} sx={{ variant: `links.secondary`, marginTop: `32px`}} to={replaceSlashes(`/${basePath}/${tagsPath}`)}>
          View all tags
        </TLink>
        </Flex>
        <Listing posts={posts} sx={{ mt: [4, 5] }} />
        </div>
    </Layout>
  )
}

export default Blog